module.exports = __webpack_public_path__ + "static/media/animated_nagraj.17c244a2.png";